<template>
  <div>
    <Nav title="本期幸运码" />
    <div class="lucky_codes_bg">
      <prize
        class="lucky_codes_header"
        v-if="dataModel != null && dataModel.award != null"
        :prizeIndex="dataModel.num.toString()"
        :prizeName="dataModel.award.name"
        :prizePrice="dataModel.award.price.toString()"
        :prizeImage="dataModel.award.picture"
      />
      <div class="lucky_codes_list">
        <div
          class="lucky_codes_list_header"
          v-if="curWinner != null && curWinner.luckyCode.length > 0"
        >
          <div class="lucky_codes_list_header_phone">
            {{ curWinner.userName }}
          </div>
          <img
            class="lucky_codes_list_header_image"
            src="../../assets/lottery/winning_bg.png"
          />
          <div class="lucky_codes_list_header_title">中奖了</div>
          <div class="lucky_codes_list_header_code">
            {{ curWinner.luckyCode }}
          </div>
        </div>
        <table
          class="lucky_codes_list_table"
          v-for="(value, index) in datas"
          :key="index"
        >
          <div class="lucky_codes_list_table_name">
            {{ value.userName }}
          </div>
          <div class="lucky_codes_list_table_title">
            {{ isStatusText(index) }}
          </div>
          <div class="lucky_codes_list_table_code">{{ value.code }}</div>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import Nav from "../../components/nav/Nav.vue";
import Prize from "../../components/lottery/Prize.vue";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import {
  LotteryModel,
  CurWinner,
  LuckyCodes
} from "../../model/lottery/LotteryModel";

@Options({
  components: {
    Nav,
    Prize
  }
})
export default class LuckyCodesList extends Vue {
  private dataModel: LotteryModel | null = null;
  private datas: LuckyCodes[] = [];
  private curWinner: CurWinner | null = null;

  mounted() {
    this.getLotteryData();
    this.curWinnerData();
    this.luckyCodes();
  }
  getLotteryData() {
    Http.get<LotteryModel>(Urls.lottery_curPhase).then(
      (res: LotteryModel) => {
        this.dataModel = res;
      },
      (err: ResponseData) => {
        console.log(Urls.lottery_curPhase, err.message);
        // openToast(err.message);
      }
    );
  }
  curWinnerData() {
    Http.get<CurWinner>(Urls.lottery_curWinner).then(
      (res: CurWinner) => {
        this.curWinner = res;
      },
      (err: ResponseData) => {
        console.log(Urls.lottery_curWinner, err.message);
        // openToast(err.message);
      }
    );
  }
  luckyCodes() {
    Http.get<LuckyCodes[]>(Urls.lottery_luckyCodes).then(
      (res: LuckyCodes[]) => {
        this.datas = res;
      },
      (err: ResponseData) => {
        console.log(Urls.lottery_luckyCodes, err.message);
        // openToast(err.message);
      }
    );
  }
  isStatusText(index: number) {
    if (this.datas[index].status == 0) {
      return "未开奖";
    } else if (this.datas[index].status == 1) {
      return "中奖了";
    } else if (this.datas[index].status == -1) {
      return "未中奖";
    }
    return "";
  }
}
</script>

<style lang="less">
.lucky_codes_bg {
  background-color: #f6f6f6;
  width: 100%;
  position: fixed;
  margin: 0 auto;
  left: 0px;
  bottom: 0;
  top: 44px;
  overflow-y: scroll;
  .lucky_codes_header {
    margin-top: 20px;
  }
  .lucky_codes_list {
    background-color: white;
    border-radius: 0px 0px 10px 10px;
    padding-bottom: 17px;
    margin: 10px 20px 20px 20px;
    background-color: white;
    border-radius: 10px;
    padding: 14px 7px;
    /// 中奖title
    .lucky_codes_list_header {
      background-color: #f64746;
      border-radius: 10px;
      height: 52px;
      margin-bottom: 8px;
      .lucky_codes_list_header_phone {
        float: left;
        color: #ffffff;
        font-size: 15px;
        margin: 16px 0px 16px 10px;
        font-weight: bold;
        width: 30%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
        // background-color: yellow;
        line-height: 20px;
      }
      .lucky_codes_list_header_code {
        float: left;
        color: #ffffff;
        font-size: 15px;
        text-align: right;
        margin: 16px 10px 16px 0px;
        font-weight: bold;
        // background-color: yellow;
        line-height: 20px;
        float: right;
      }
      .lucky_codes_list_header_title {
        color: #ffffff;
        font-size: 15px;
        text-align: right;
        float: left;
        font-weight: bold;
        margin: 16px 10px 16px 0px;
        // background-color: yellow;
        line-height: 20px;
        float: right;
      }
      .lucky_codes_list_header_image {
        float: right;
        margin: 0 auto;
        height: 100%;
      }
    }
    /// 中奖列表
    .lucky_codes_list_table {
      width: 100%;
      padding: 8px 9px 0px 9px;
      .lucky_codes_list_table_name {
        float: left;
        font-size: 14px;
        color: #111111;
        width: 45%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 20px;
      }
      .lucky_codes_list_table_code {
        float: right;
        font-size: 14px;
        color: #111111;
        text-align: left;
        line-height: 20px;
        width: 20%;
      }
      .lucky_codes_list_table_title {
        line-height: 20px;
        font-size: 14px;
        color: #111111;
        float: right;
        margin-left: 10px;
      }
    }
  }
}
</style>
